import { Dialog, DialogContent } from "@material-ui/core";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

import SubmitOrder from "../components/SubmitOrder";

export interface ModalOrderProcessingProps {
  onClose?: () => void;
  visible?: boolean;
}

export const useStyles = makeStyles(
  () => ({
    closeDialog: {
      cursor: "pointer"
    },
    root: {
      "& .MuiPaper-root": {
        maxWidth: 560,
        width: "100%",
        borderRadius: 12
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24
      },
      "& .MuiDialogContent-root": {
        padding: 0,
        margin: 0
      }
    }
  }),
  { name: "ModalOrderProcessing" }
);

const ModalOrderProcessing: React.FC<ModalOrderProcessingProps> = props => {
  const { visible, onClose } = props;
  const classes = useStyles();

  return (
    <>
      <Dialog open={visible} onClose={onClose} className={classes.root}>
        <DialogContent dividers={false}>
          <SubmitOrder />
        </DialogContent>
      </Dialog>
    </>
  );
};

ModalOrderProcessing.displayName = "ModalOrderProcessing";
export default ModalOrderProcessing;
